import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Home } from "lucide-react";
import { api, fmtErr } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export function MagicConsume() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useState(() => {
    const token = params.get("token") || "";
    api.post("/auth/magic", { token })
      .then((r) => { setUser(r.data); navigate("/account", { replace: true }); })
      .catch((e) => setError(fmtErr(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-card p-8 shadow-sm">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <span className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center"><Home className="w-4 h-4 text-primary-foreground" /></span>
          <span className="font-heading font-bold">Tendly</span>
        </Link>
        <h1 className="font-heading font-bold text-2xl tracking-tight">Signing you in…</h1>
        <p className="mt-1 text-sm text-muted-foreground">{error || "One moment."}</p>
        {error && <div className="mt-6"><Link to="/account" data-testid="magic-retry" className="text-sm text-primary hover:underline">Request a new link</Link></div>}
      </div>
    </div>
  );
}
